import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import axios from "axios";

// helpers/services in your project
import { authHeader } from "_helpers";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { Label, Input, FormGroup } from "reactstrap";
import Datetime from "react-datetime";

// core components (match your project structure)
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";
import TSText from "components/Forms/TSText";
import TSSelect2 from "components/Forms/TSSelect2";
import TSUser from "components/Forms/TSUser";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import { Collapse, Modal, ModalBody } from "reactstrap";

import {
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper, TableSortLabel, TableFooter, TablePagination,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@material-ui/core';

import "react-datetime/css/react-datetime.css";
import "./custom-style.css";
import zIndex from "@material-ui/core/styles/zIndex";

// -------------------- Styles --------------------
const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: 0,
    fontSize: "14px",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: 0,
    minHeight: "auto",
    fontWeight: 300,
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none",
  },
  cardTitleCustom: {
    background: "linear-gradient(to right, #2193b0, #6dd5ed)",
    margin: "-20px 15px 15px 15px",
  },
};
const useStyles = makeStyles(styles);

// -------------------- Component --------------------
const TeamGroup = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const user = useSelector((state) => state.auth.user);

  const { location } = props;
  const _teamGroupKeyFromRoute = props.match?.params?.TeamGroupKey ?? null; // e.g. /team-group/request/:TeamGroupKey

  const moment = require("moment");
  require("moment/locale/th");

  const [Keyword, setKeyword] = useState('');
  // ------- Form State -------
  const [TeamGroupKey, setTeamGroupKey] = useState(null);
  const [TeamGroupTypeKey, setTeamGroupTypeKey] = useState('');
  const [FilterTeamGroupTypeKey, setFilterTeamGroupTypeKey] = useState('');

  const [editKey, setEditKey] = useState(null);
  const [Code, setCode] = useState("");
  const [Name, setName] = useState(""); // ชื่อกรรมการ/ชื่อกลุ่ม

  // Lookups
  const [ArrTeamGroupType, setArrTeamGroupType] = useState([]);
  const [ArrTeamGroupRole, setArrTeamGroupRole] = useState([]);

  // Members
  const [Members, setMembers] = useState([]); // [{ userName, teamGroupUserKey?, teamGroupRoleKey? }]

  // UI
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modalError, setModalError] = useState(false);
  const [modalCancel, setModalCancel] = useState(false);
  const [errMsg, setErrMsg] = useState([]);
  const [icon, setIcon] = useState("far fa-question-circle");
  const [isOpen, setIsOpen] = useState(false);
  const [isShowList, setIsShowList] = useState(true);


  //Table
    const [dataList, setDataList] = useState([]);
    const [selectedData, setSelectedData] = useState(null);
    const [orderDirection, setOrderDirection] = useState('desc');
    const [orderBy, setOrderBy] = useState('code'); // default column to sort
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);

  // -------------------- Effects: Load lookups & edit data --------------------
  useEffect(() => {
    // lookups
    axios("/api/v1/team/teamgrouptype").then(
      (res) => {
        const data = res?.data?.data ?? [];
        const json = JSON.parse(
          JSON.stringify(data)
            .split('"name":').join('"label":')
            .split('"teamGroupTypeKey":').join('"value":')
        );
        setArrTeamGroupType(json);
      },
      (e) => console.log(e)
    );

    axios("/api/v1/team/teamgrouprole").then(
      (res) => {
        const data = res?.data?.data ?? [];
        const json = JSON.parse(
          JSON.stringify(data)
            .split('"name":').join('"label":')
            .split('"teamGroupRoleKey":').join('"value":')
        );
        setArrTeamGroupRole(json);
      },
      (e) => console.log(e)
    );

    // edit mode via route or location.state
    const _editKey = location?.state?.TeamGroupKey || _teamGroupKeyFromRoute;
    setEditKey(_editKey)
    if (editKey) {
      axios(`/api/v1/team/teamgroup/${editKey}`).then(
        async (res) => {
          const g = res?.data?.data;
          if (!g) return;
          setTeamGroupKey(g.teamGroupKey);
          setTeamGroupTypeKey(g.teamGroupTypeKey);
          setCode(g.code || "");
          setName(g.name || "");

          // load members
          const mres = await axios.get(`/api/v1/team/teamgroupuser`, { params: { TeamGroupKey: g.teamGroupKey } });
          const list = mres?.data?.data ?? [];
          setMembers(
            list.map((x) => ({
              teamGroupUserKey: x.teamGroupUserKey,
              teamGroupKey: x.teamGroupKey,
              userName: x.userName,
              teamGroupRoleKey: x.teamGroupRoleKey,
              firstName: x.firstName,
              lastName: x.lastName
            }))
          );
        },
        (e) => console.log(e)
      );
    }
  }, [location?.state?.TeamGroupKey, _teamGroupKeyFromRoute, editKey, TeamGroupKey]);

  useEffect(() => {
    fetchDataList();
  }, [Keyword, FilterTeamGroupTypeKey]);
  
  const fetchDataList = async () => {
        try {
            const response = await axios.get('/api/v1/team/teamgroup?name=' + Keyword + '&teamGroupTypeKey=' + FilterTeamGroupTypeKey);
            if (response.data.result === 200) {
                setDataList(response.data.data);
            } else {
                setDataList([]);
            }
        } catch (error) {
            console.error('Error fetching dataList:', error);
            setDataList([]);
        }
    };
  // -------------------- Handlers --------------------
  const handleSubmit = (evt) => {
    evt.preventDefault();
    let cntErr = 0;
    const msgs = [];

    if (!TeamGroupTypeKey) { cntErr++; msgs.push(<li key={cntErr-1}>{"กรุณาเลือก ประเภทกรรมการ"}</li>); }
    if (!Code || !Code.trim()) { cntErr++; msgs.push(<li key={cntErr-1}>{"กรุณาระบุ Code"}</li>); }
    if (!Name || !Name.trim()) { cntErr++; msgs.push(<li key={cntErr-1}>{"กรุณาระบุ ชื่อกลุ่ม/ชื่อกรรมการ"}</li>); }
    if (Members == null || Members.length === 0) { cntErr++; msgs.push(<li key={cntErr-1}>{"กรุณาระบุ สมาชิกอย่างน้อย 1 คน"}</li>); }

    if (cntErr > 0) { setErrMsg(msgs); setModalError(true); return; }
    setModal(true);
  };

  const handleConfirm = async (evt) => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

    try {
      const payload = { code: Code.trim(), name: Name.trim(), teamGroupTypeKey: TeamGroupTypeKey };
      let groupKey = TeamGroupKey;

      if (groupKey) {
        await axios.put(`/api/v1/team/teamgroup/${groupKey}`, payload);
      } else {
        const created = await axios.post(`/api/v1/team/teamgroup`, payload);
        // support both {data:{teamGroupKey}} or raw {teamGroupKey}
        const d = created?.data;
        groupKey = (d?.data?.teamGroupKey ?? d?.teamGroupKey);
        setTeamGroupKey(groupKey);
      }

      // Sync members: fetch current, then diff
      const curRes = await axios.get(`/api/v1/team/teamgroupuser`, { params: { TeamGroupKey: groupKey } });
      const current = curRes?.data?.data ?? [];

      const wantedMap = new Map();
      Members.forEach((m) => wantedMap.set(m.userName, m));
      const currentMap = new Map();
      current.forEach((m) => currentMap.set(m.userName, m));

      // Deletes
      for (const uname of currentMap.keys()) {
        if (!wantedMap.has(uname)) {
          await axios.delete(`/api/v1/team/teamgroupuser/${currentMap.get(uname).teamGroupUserKey}`);
        }
      }
      // Creates / Updates
      for (const uname of wantedMap.keys()) {
        const desired = wantedMap.get(uname);
        if (!currentMap.has(uname)) {
          await axios.post(`/api/v1/team/teamgroupuser`, {
            teamGroupKey: groupKey,
            userName: uname,
            teamGroupRoleKey: desired.teamGroupRoleKey ?? null,
          });
        } else {
          const cur = currentMap.get(uname);
          const changed = (cur.teamGroupRoleKey || null) !== (desired.teamGroupRoleKey || null);
          if (changed) {
            await axios.put(`/api/v1/team/teamgroupuser/${cur.teamGroupUserKey}`, {
              teamGroupKey: groupKey,
              userName: uname,
              teamGroupRoleKey: desired.teamGroupRoleKey ?? null,
            });
          }
        }
      }

      setIcon("far fa-question-circle");
      setModal(false);
      setModal2(true);
    } catch (e) {
      console.error(e);
      setIcon("far fa-question-circle");
      setModal(false);
      setErrMsg([e?.response?.data?.msg || e?.message || "บันทึกไม่สำเร็จ"]);
      setModalError(true);
    }
  };

  const handleCancel = async (evt) => {
    evt.preventDefault();
    // ไม่มี use case ยกเลิก TeamGroup แบบ request เดิม ถ้าต้องการให้ archive/disable แจ้งผมได้
    setModalCancel(false);
  };

  const handleClear = async (evt) => {
    //evt.preventDefault();
    // ไม่มี use case ยกเลิก TeamGroup แบบ request เดิม ถ้าต้องการให้ archive/disable แจ้งผมได้
    setIsShowList(true);
    setTeamGroupKey(0);
    setCode("");
    setName("");
    setEditKey(null);
    setSelectedData([]);
    setMembers([]);
    setModalCancel(false);
  };

  const GotoEdit = (evt) => {
    evt.preventDefault();
    setModal2(false);
    if (TeamGroupKey) {
      history.push({ pathname: "/team/group/" + TeamGroupKey });
    }
  };

  const handleAdd = () => {
        //clearForm();
        //setModalOpen(true);
        setIsShowList(false);
  };

  const handleEdit = (index, _data) => {
        //setEditIndex(index);
        //setIsEditing(true);
        //setSelectedData(_data);
        //setModalOpen(true);
        setIsShowList(false);
        setEditKey(_data.teamGroupKey);
    };

  const handleMembersChange = (users) => {
    // Normalize selection into { userName, firstName, lastName }
    // and set default role = 6 if not already assigned.
    // Note: TSUser items may contain either { userName, firstName, lastName }
    // or { value, label } — we try to capture names when available.
    const norm = users.map((u) => ({
      userName: u.userName || u.value || u,
      firstName: u.firstName || u.givenName || "",
      lastName: u.lastName || u.familyName || "",
    }));

    const byName = new Map(Members.map((m) => [m.userName, m]));

    const merged = norm.map((n) => {
    const prev = byName.get(n.userName) || {};
    const role = (prev.teamGroupRoleKey ?? null) != null ? prev.teamGroupRoleKey : 5; //default 5 = กรรมการ
      return {
        ...prev,
        userName: n.userName,
        firstName: n.firstName || prev.firstName || "",
        lastName: n.lastName || prev.lastName || "",
        teamGroupRoleKey: role,
      };
    });

    setMembers(merged);
  };

  const handleRequestSort = (property) => {
        const isAsc = orderBy === property && orderDirection === 'asc';
        setOrderDirection(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
  };

  const sortedData = () => {
        return dataList.sort((a, b) => {
            if (orderDirection === 'asc') {
                return a[orderBy] < b[orderBy] ? -1 : 1;
            }
            return a[orderBy] > b[orderBy] ? -1 : 1;
        });
  };

  const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


  const handleRoleChange = (userName, roleOption) => {
    setMembers((prev) =>
      prev.map((m) => (m.userName === userName ? { ...m, teamGroupRoleKey: roleOption?.value ?? null } : m))
    );
  };

  // -------------------- Render --------------------
  return (
    <div>
      <Grid>

        <Col xs={12} sm={12} md={12} style={{ display: isShowList ? 'block': 'none' }}>
          <Card>
                <CardHeader color="primary">
                    <h4 className={classes.cardTitleWhite}>รายการคณะกรรมการ</h4>
                </CardHeader>
                <CardBody>
                    <div>
                        <Grid>
                            <Col xs={12} sm={6} md={6}>
                                <TSText icon="far fa-edit" label="คำค้นหา" value={Keyword} onChange={e => setKeyword(e.target.value)} />
                            </Col>
                            <Col xs={12} sm={6} md={6}>
                                <TSSelect2 isClearable={true} label="FilterTeamGroupTypeKey" options={ArrTeamGroupType} value={FilterTeamGroupTypeKey} onChange={e => setFilterTeamGroupTypeKey(e != null ? e.value : '') } />
                            </Col>
                        </Grid>

                        {/* Add more fields as necessary for other properties */}
                        <Col xs={12} sm={12} md={12} style={{ textAlign: 'right' }}>

                            <Button
                                color="success"
                                type="button"
                                onClick={handleAdd}
                            >
                                <h4><i className={"fa fa-plus"}> เพิ่มคณะกรรมการ</i></h4>
                            </Button>

                        </Col>
                        <TableContainer component={Paper} className={classes.tableContainer}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            <TableSortLabel
                                                active={orderBy === 'code'}
                                                direction={orderBy === 'code' ? orderDirection : 'asc'}
                                                onClick={() => handleRequestSort('code')}
                                            >
                                                รหัสคณะกรรมการ
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell>
                                            <TableSortLabel
                                                active={orderBy === 'name'}
                                                direction={orderBy === 'name' ? orderDirection : 'asc'}
                                                onClick={() => handleRequestSort('name')}
                                            >
                                                ชื่อคณะกรรมการ
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell style={{ display: (FilterTeamGroupTypeKey == 0 ? 'table-cell' : 'none') }}>
                                            <TableSortLabel
                                                active={orderBy === 'teamGroupTypeKey'}
                                                direction={orderBy === 'teamGroupTypeKey' ? orderDirection : 'asc'}
                                                onClick={() => handleRequestSort('teamGroupTypeKey')}
                                            >
                                                ประเภท
                                            </TableSortLabel>
                                        </TableCell>                                                     
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {sortedData()
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((data, index) => (
                                            <TableRow key={index} className={classes.tableRow}>
                                                <TableCell>
                                                    <Label style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => handleEdit(index, data)}>
                                                        {data.code}
                                                    </Label>
                                                </TableCell>
                                                <TableCell>
                                                    <Label style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => handleEdit(index, data)}>
                                                        {data.name}
                                                    </Label>
                                                </TableCell>
                                                <TableCell style={{ paddingLeft: '10px', display: (FilterTeamGroupTypeKey == 0 ? '' : 'none') }} className={classes.tableCell}>{(data.teamGroupTypeKey != null && ArrTeamGroupType.find(t => t.value == data.teamGroupTypeKey) != null) ? ArrTeamGroupType.find(t => t.value == data.teamGroupTypeKey).label : ''}</TableCell>                                              
                                            </TableRow>
                                        ))}
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            rowsPerPageOptions={[5, 10, 25]}
                                            count={dataList.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                        />
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </TableContainer>
                    </div>
                </CardBody>
                <CardFooter>

                </CardFooter>
          </Card>
      </Col>


        <Col xs={12} sm={12} md={12} style={{ display: !isShowList ? 'block': 'none' }}>
          <Card>
            <CardHeader className={classes.cardTitleCustom}>
              <h4 className={classes.cardTitleWhite}>แบบฟอร์มบันทึก TeamGroup</h4>
              <p className={classes.cardCategoryWhite}>กรุณาระบุรายละเอียด</p>
            </CardHeader>
            <CardBody>
              <Grid>
                <Col xs={12} sm={12} md={12}>
                  <TSText icon="far fa-edit" label="ชื่อคณะกรรมการ" value={Name} onChange={(e) => setName(e.target.value)} />
                </Col>
                <Col xs={12} sm={12} md={6}>
                  <TSSelect2
                    label="ประเภทกรรมการ"
                    options={ArrTeamGroupType}
                    value={TeamGroupTypeKey}
                    onChange={(e) => setTeamGroupTypeKey(e.value)}
                    zIndex={4}
                  />
                </Col>
                <Col xs={12} sm={12} md={6}>
                  <TSText icon="far fa-edit" label="รหัส/ชื่อย่อ" value={Code} onChange={(e) => setCode(e.target.value)} />
                </Col>


              </Grid>
            </CardBody>
          </Card>
        </Col>

        {/* Members */}
        <Col xs={12} sm={12} md={12} style={{ display: !isShowList ? 'block': 'none' }}>
          <Card>
            <CardHeader className={classes.cardTitleCustom}>
              <h4 className={classes.cardTitleWhite}>เจ้าหน้าที่</h4>
              <p className={classes.cardCategoryWhite}></p>
            </CardHeader>
            <CardBody>
              <Grid>
                 {/* Role picker per member */}
                {Members.length > 0 && (
                  <Col xs={12} sm={12} md={12} >
                    <div >
                      <table className="table">
                        <thead>
                          <tr>
                            <th>รายชื่อคณะกรรมการ</th>
                            <th style={{ width: 320 }}>บทบาท</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Members.map((m) => (
                            <tr key={m.userName}>
                              <td style={{padding:'3px'}}>{m.firstName} {m.lastName}</td>
                              <td style={{padding:'3px'}}>
                                <TSSelect2
                                  label=""
                                  options={ArrTeamGroupRole}
                                  value={m.teamGroupRoleKey || null}
                                  onChange={(opt) => handleRoleChange(m.userName, opt)}  
                                                         
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Col>
                )}
                
                <Col xs={12} sm={12} md={12} style={{zIndex:'1'}}>
                  <TSUser value={Members} isMultiple={true} onChange={handleMembersChange} />
                </Col>
               
              </Grid>
            </CardBody>
          </Card>
        </Col>

        {/* Save/Cancel */}
        <Col xs={12} sm={12} md={12} style={{ display: !isShowList ? 'block': 'none' }}>
          <Card>
            <CardHeader className={classes.cardTitleCustom}>
              <h4 className={classes.cardTitleWhite}>บันทึกข้อมูล</h4>
              <p className={classes.cardCategoryWhite}></p>
            </CardHeader>
            <CardBody>
              <Grid>
                <Col xs={12} sm={12} md={5} style={{ height: "48px" }}>
                  <Button color={TeamGroupKey ? "warning" : "info"} onClick={handleSubmit} fullWidth>
                    <i className={TeamGroupKey ? "fa fa-edit" : "fa fa-save"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
                    <h4>{TeamGroupKey ? "แก้ไข" : "บันทึก"}</h4>
                  </Button>
                </Col>
                <Col xs={12} sm={12} md={2}></Col>
                <Col xs={12} sm={12} md={5} style={{ height: "48px" }}>
                  <Button color="danger" onClick={() => setModalCancel(true)} fullWidth>
                    <i className={"fa fa-ban"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
                    <h4>ยกเลิก</h4>
                  </Button>
                </Col>
              </Grid>
              <Grid><Col>&nbsp;</Col></Grid>
            </CardBody>
          </Card>
        </Col>
      </Grid>

      {/* Modals */}
      <CardFooter>
        <Collapse isOpen={isOpen}></Collapse>

        {/* Confirm */}
        <Modal toggle={() => setModal(false)} isOpen={modal}>
          <div className="modal-header justify-content-center">
            <div>
              <i className={icon} style={{ color: "blue", fontSize: "2em" }}></i>
            </div>
          </div>
          <ModalBody>
            <p style={{ textAlign: "center", fontSize: "1.8em" }}>
              {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg" ? "ยืนยันการบันทึกข้อมูล" : "กำลังตรวจสอบข้อมูล"}
            </p>
          </ModalBody>
          <div className="modal-footer">
            <Button color="success" type="button" onClick={handleConfirm} disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}>
              <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
              <h4>ยืนยัน</h4>
            </Button>
            <Button color="danger" type="button" onClick={() => { setIcon("far fa-question-circle"); setModal(false); }}>
              <i className={"fa fa-thumbs-down"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
              <h4>ยกเลิก</h4>
            </Button>
          </div>
        </Modal>

        {/* Cancel (placeholder) */}
        <Modal toggle={() => setModalCancel(false)} isOpen={modalCancel}>
          <div className="modal-header justify-content-center">
            <div>
              <i className={icon} style={{ color: "red", fontSize: "2em" }}></i>
            </div>
          </div>
          <ModalBody>
            <p style={{ textAlign: "center", fontSize: "1.8em" }}>
              {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg" ? "ปิดหน้าฟอร์มนี้หรือไม่?" : "กำลังตรวจสอบข้อมูล"}
            </p>
          </ModalBody>
          <div className="modal-footer">
            <Button color="success" type="button" onClick={(e)=>{ handleClear(); }} disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}>
              <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
              <h4>ยืนยัน</h4>
            </Button>
            <Button color="danger" type="button" onClick={() => { setIcon("far fa-question-circle"); setModalCancel(false); }}>
              <i className={"fa fa-thumbs-down"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
              <h4>ปฏิเสธ</h4>
            </Button>
          </div>
        </Modal>

        {/* Success */}
        <Modal toggle={GotoEdit} isOpen={modal2}>
          <div className="modal-header justify-content-center">
            <div>
              <i className={"fas fa-check"} style={{ color: "green", fontSize: "4em" }}></i>
            </div>
          </div>
          <ModalBody>
            <p style={{ textAlign: "center", fontSize: "1.8em" }}>บันทึกข้อมูลสำเร็จ</p>
          </ModalBody>
          <div className="modal-footer">
            <Button color="info" type="button" onClick={GotoEdit}>
              <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
              <h4>ตกลง</h4>
            </Button>
          </div>
        </Modal>

        {/* Error */}
        <Modal toggle={() => setModalError(false)} isOpen={modalError}>
          <div className="modal-header justify-content-center">
            <div>
              <i className="fa fa-times" style={{ color: "red", fontSize: "2em" }}></i>
            </div>
          </div>
          <ModalBody>
            <p>ไม่สามารถบันทึกข้อมูลได้</p>
            <div>{errMsg}</div>
          </ModalBody>
          <div className="modal-footer justify-content-center">
            <Button color="primary" type="button" onClick={() => setModalError(false)}>
              <h4>ตกลง</h4>
            </Button>
          </div>
        </Modal>
      </CardFooter>
    </div>
  );
};

export default TeamGroup;
